'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('toc_policy', {
      url: '/account/toc_policy',
      template: '<toc-policy></toc-policy>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/toc_policy/toc_policy.routes.js